import { render } from "./FooterPartial.vue?vue&type=template&id=6352aa18"
import script from "./FooterPartial.vue?vue&type=script&lang=js"
export * from "./FooterPartial.vue?vue&type=script&lang=js"

import "./FooterPartial.vue?vue&type=style&index=0&id=6352aa18&lang=css"
script.render = render

export default script